import { requestTimeout, clearRequestTimeout } from 'nandos-timing-utils'
import Toggleable from '../../mixins/toggleable'
import Contextualable from '../../mixins/contextualable'
import Positionable from '../../mixins/positionable'
import PrefersReducedMotion from '../../utils/prefers-reduced-motion'

export default {
  name: 'snackbar',

  mixins: [Contextualable, Positionable, Toggleable],

  props: {
    moveAboveFooter: { type: Boolean },
    dismissable: { type: Boolean },
    timeout: { type: Number, default: 3500 },
    message: { type: String },
    link: { type: [String, Object] },
    template: { type: String }
  },

  data () {
    return {
      timer: null
    }
  },

  computed: {
    classes () {
      return {
        ...this.$contextualClasses,
        'snack': true,
        'snack--above-footer': this.moveAboveFooter,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--fixed': this.fixed || !this.absolute,
        'snack--right': this.right,
        'snack--top': this.top,
      }
    },

    computedTransition () {
      return PrefersReducedMotion
        ? 'transition'
        : this.top ? 'n-snack-bar-top-transition' : 'n-snack-bar-bottom-transition'
    }
  },

  watch: {
    isActive: {
      handler() {
        if(this.timer) clearRequestTimeout(this.timer)

        if (this.isActive && this.timeout) {
          this.timer = requestTimeout(() => this.isActive = false, this.timeout)
        }
      },
      immediate: true
    }
  },

  render (h) {


    let snackEl = null

    if (this.isActive) {
      
      const children = []

      let messageContent = null
      if(this.template) {
        messageContent = h({template: "<div>" + this.template + "</div>"})
      }
      else if(this.link) {
        messageContent = h('n-button', {
            props: {
              router: true,
              to: this.link.path || this.link,
              jump: this.link.jump,
              redirect: this.link.redirect,
              block: true,
              flat: true,
              secondary: true,
            },
            nativeOn: { click: () => this.isActive = false },
          }, [this.message])
      }
      else {
        messageContent = this.message
      }

      let closeBtn = h('n-button', {
            class: 'snack__dismiss-btn',
            props: { icon: true, flat: true, small: true },
            nativeOn: { click: () => this.isActive = false },
          }, [ h('n-icon', 'close') ])

      children.push(h('div', {
        'class': 'snack__content'
      }, [messageContent, this.$slots.default, this.dismissable ? closeBtn : null]))

      snackEl = h('div', {'class': this.classes}, children)
    }

    return h(this.computedTransition, {}, [ this.isActive ? snackEl : null])
  },

  beforeDestroy() {
    if(this.timer) clearRequestTimeout(this.timer)
  }
}




